import { ContextService } from '../../services/context_service';
import { DatenauswertungJahrauswahlEinzeln } from '../datenauswertung/DatenauswertungJahrauswahlEinzeln';
import datenauswertungStyle from '../datenauswertung/datenauswertung.less'
import { Document, Image, Link, Page, pdf, Text, View } from '@react-pdf/renderer';
// import { getHauptzollamt } from './ZusatztoolsSteuerStromUtil';
import { i18n } from '../../i18n/i18n';
import { IDs } from '../../helpers/IDs';
import { isEnableEnergiesteuerrueckerstattung } from '../dateneingabe//assistent/assistent_helpers';
import { lazyInject } from '../../services/inversify';
import * as Moment from 'moment';
import { parsePdfSub2 } from '../datenauswertung/generisch/helper';
import * as React from 'react';
import { renderText } from '../dateneingabe/assistent/assistent_helpers';
import { SectionStyle } from '../../helpers/SectionStyle';
import { WActionButton } from '../../core/elements/WActionButton';
import { WpdfText } from '../datenauswertung/pdf/WpdfText.';
import { WpdfView } from '../datenauswertung/pdf/WpdfView';
import { WSpinner } from '../../core/elements/spinner/WSpinner';
import { ZusatztoolsSteuerEnergie } from './ZusatztoolsSteuerEnergie';
import { ZusatztoolsSteuerStrom } from './ZusatztoolsSteuerStrom';

interface ZusatztoolsSteuerProps extends React.ClassAttributes<any> {
    data: any;
}

interface ZusatztoolsSteuerState {
    isLoading: boolean;
    jahr: number;
    jahrMax: number;
    jahrMin: number;
    hauptzollamt: string;
}

export class ZusatztoolsSteuer extends React.Component<ZusatztoolsSteuerProps, ZusatztoolsSteuerState> {

    constructor(props: any) {
        super(props);
        const jahr_context = this.contextService.get('jahr_cockpit');
        this.state = {
            isLoading: false,
            jahr: jahr_context,
            jahrMax: null,
            jahrMin: null,
            hauptzollamt: undefined
        };
    }

    @lazyInject(ContextService) private contextService: ContextService;

    componentDidMount(): void {
        this.getJahre();
        /*
        const systemparameter = this.props.data[IDs.ENT_SYSTEMPARAMETER];

        if (systemparameter && systemparameter.length > 0) {
            const param = systemparameter.find((p: any) => p.parameter === 'url_suche_steuer_zoll_plz');
            const unternehmensdaten = this.props.data[IDs.ENT_UNTERNEHMENSDATEN];
            if (unternehmensdaten && unternehmensdaten.length > 0 && param && param.wert) {
                const plz = +unternehmensdaten[0].plz;
                const url = param.wert;
                getHauptzollamt(plz, url, (hauptzollamt: string) => this.setState({hauptzollamt}));
            }
        }
        */
    }

    getJahre(): void {
        const startjahr: number = ((this.props.data[IDs.ENT_KONFIGURATION] || [])
            .find((item: any) => item.startjahr_datenerfassung) || {}).startjahr_datenerfassung || null;
        const jahrMax: number = new Date().getFullYear() - 1;
        const jahrMin: number = +startjahr > 1900 ? startjahr : 2010;
        this.setState({ jahr: this.state.jahr || jahrMax, jahrMax, jahrMin });
    }

    getStyle(isPdf?: boolean): any {
        const [colorSection, rowBgColor] = new SectionStyle().getPropertyValues(['--color-section-main', '--color-breadcrumb-background']);

        return ({
            header: {
                fontFamily: 'Helvetica-Bold',
                fontSize: '18pt',
                width: '100%',
                height: 60,
                top: 0,
                left: 0,
                padding: 0,
                borderTop: '20 solid white',
                borderRight: '20 solid white',
                borderLeft: '20 solid white',
                position: 'relatitive',
                display: 'block',
                boxSizing: 'border-box'
            },
            headerImage: {
                width: 241,
                height: 40,
                top: 0,
                right: 0,
                position: 'absolute',
                display: 'inline-block'
            },
            headerText: {
                marginTop: -3
            },
            headerSubText: {
                fontSize: '16pt',
                color: colorSection || '#5e8bc2',
                marginTop: 2
            },
            footer: {
                fontSize: '8pt',
                top: '287mm',
                left: 0,
                width: '100%',
                height: 'auto',
                padding: '0 20px',
                position: 'absolute',
                display: 'block',
                boxSizing: 'border-box'
            },
            link: {
                ...(isPdf && { fontFamily: 'Helvetica-Bold' }),
                fontSize: '9pt',
                fontWeight: 'bold',
                maxWidth: 650,
                margin: '10px 20px 0 0',
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                boxSizing: 'border-box'
            },
            info: {
                backgroundColor: rowBgColor,
                maxWidth: 645,
                marginTop: 20,
                padding: '0 10px 0 10px',
                border: '1px solid #ccc',
                borderRadius: 5,
                boxSizing: 'border-box',
                fontSize: '11pt',
                textAlign: 'justify',
                hyphens: 'auto'
            },
            hinweise: {
                fontSize: '9pt'
            },
            h_row: {
                display: 'flex',
                flexDirection: 'row'
            },
            h_col1: {
                maxWidth: 20,
                margin: '10px 0 0 0'
            },
            h_col2: {
                maxWidth: isPdf ? 500 : 620,
                margin: '10px 20px 0 14px'
            },
            page: {
                padding: '40px 40px 20px 40px'
            }
        });
    }

    async processPdf(pdfData: JSX.Element): Promise<void> {
        try {
            const blob = await pdf(pdfData).toBlob();
            const pdfString: string = URL.createObjectURL(blob);
            this.setState({ isLoading: false });
            const filename: string = (
                `${i18n('Strom-, Energiesteuer', 'sys')} ` +
                `[${(new Date()).toLocaleDateString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit' })}]` +
                '.pdf'
            );
            saveAs(pdfString, filename);
        } catch (error) {
            // console.log('error: ', error);
        }
    }

    render(): JSX.Element {
        if (!this.state.jahr) {
            return <div>{i18n('Lade', 'sys')}...</div>;
        }

        const styles: any = this.getStyle(true);

        const untData = (this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0];
        const wzTid = (untData || {}).wz_tid_orig;
        const wzData = (this.props.data[IDs.ENT_GEWERKE_WZ] || []).find((r: any) => r.tid === wzTid);
        const wzCode = (wzData || {}).code_2003 || '';

        let enableSteuerEnergie = true;
        if (this.props.data.MODUL_SELECTED === 'steuer') {
            const konfiguration: any[] = this.props.data[IDs.ENT_KONFIGURATION] || [];
            enableSteuerEnergie = isEnableEnergiesteuerrueckerstattung(konfiguration);
        }

        return (
            <div style={{ display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                <div
                    className={datenauswertungStyle.datenauswertungOuterFormContainer}
                    style={{ fontSize: '10pt', alignItems: 'center', justifyContent: 'space-between' }}
                >
                    {this.renderJahresauswahl()}
                    {this.renderPdfButton()}
                </div>
                <div style={styles.info}>
                    {renderText('Strom- & Energiesteuer', this.props.data)}
                </div>
                <div style={{
                    ...styles.info,
                    padding: 10,
                    textAlign: 'center'
                }}>
                    {i18n('WZ-Schlüssel ({{1}}) Ihres Unternehmens', 'sys').replace('{{1}}', 2003)}: <span style={{ fontWeight: 'bold', borderBottom: '2px solid black' }}>{wzCode}</span>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ width: 680 }}>
                        <ZusatztoolsSteuerStrom
                            data={this.props.data}
                            jahr={this.state.jahr}
                            hauptzollamt={this.state.hauptzollamt}
                        />
                    </div>
                    {this.renderLinks('strom')}
                </div>
                {enableSteuerEnergie &&
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <div style={{ width: 680 }}>
                            <ZusatztoolsSteuerEnergie
                                data={this.props.data}
                                jahr={this.state.jahr}
                            />
                        </div>
                        {this.renderLinks('energie')}
                    </div>
                }
                {this.renderHinweise()}
                {this.state.isLoading && <WSpinner label='PDF...' />}
            </div>
        );
    }

    renderHinweise(isPdf?: boolean): JSX.Element {
        const styles: any = this.getStyle(isPdf);
        const url_direktlink = 'https://www.zdh.de/fileadmin/Neue_Struktur/Oeffentlich/Steuern_und_Finanzen/Themen/Energie_Stromsteuer/Juni2021_Handreichung_Spitzenausgleich.pdf';
        const url_spitzenausgleich = 'https://www.zdh.de/ueber-uns/fachbereich-steuern-und-finanzen/energie-und-stromsteuer/spitzenausgleich-steuerentlastung-fuer-unternehmen-des-produzierenden-gewerbes/';
        const url_zoll = 'https://www.zoll.de/DE/Fachthemen/Steuern/Verbrauchsteuern/Strom/Steuerbeguenstigung/Steuerentlastungen/Steuerentlastung-nach-Par-10-StromStG/Grundsaetzliches/grundsaetzliches_node.html';

        return (
            <WpdfView style={styles.hinweise} pdf={isPdf}>
                <WpdfView pdf={isPdf}>
                    <WpdfText pdf={isPdf} style={{ fontSize: '9pt', margin: '20px 20px 0 0', textDecoration: 'underline' }}>
                        {i18n('Hinweise', 'sys')}
                    </WpdfText>
                </WpdfView>
                <WpdfView style={styles.h_row} pdf={isPdf}>
                    <WpdfView style={styles.h_col1} pdf={isPdf}>
                        <WpdfText pdf={isPdf}>1.</WpdfText>
                    </WpdfView>
                    <WpdfView style={styles.h_col2} pdf={isPdf}>
                        <WpdfText pdf={isPdf}>
                            {i18n('Der Antrag auf Rückerstattung der zu viel gezahlten Strom- und Energiesteuer ist bis spätestens zum {{1}} des folgenden Jahres beim zuständigen Hauptzollamt einzureichen.', 'sys').replace('{{1}}', '31.12.')}
                        </WpdfText>
                    </WpdfView>
                </WpdfView>
                <WpdfView style={styles.h_row} pdf={isPdf}>
                    <WpdfView style={styles.h_col1} pdf={isPdf}>
                        <WpdfText pdf={isPdf}>2.</WpdfText>
                    </WpdfView>
                    <WpdfView style={styles.h_col2} pdf={isPdf}>
                        <WpdfText pdf={isPdf}>
                            {i18n('In der Regel wird die auszuzahlende Entlastung dem auf der Anmeldung angegebenen Konto gutgeschrieben.', 'sys')}
                            {i18n('Ein schriftlicher Bescheid des Hauptzollamts ergeht grundsätzlich nicht.', 'sys')}
                        </WpdfText>
                    </WpdfView>
                </WpdfView>
                {/* <WpdfView style={styles.h_row} pdf={isPdf}>
                    <WpdfView style={styles.h_col1} pdf={isPdf}>
                        <WpdfText pdf={isPdf}>3.</WpdfText>
                    </WpdfView>
                    <WpdfView style={styles.h_col2} pdf={isPdf}>
                        <WpdfText pdf={isPdf}>
                            Weitere Rückzahlungen aus den von ihnen abgeführten Strom- und Energiesteuern können Unternehmen des
                            produzierenden Gewerbes bei Erfüllung entsprechender Voraussetzungen über den sog. "Spitzenausgleich" (nach § 55
                            EnergieStG, § 10 StromStG) erhalten.
                            Voraussetzung für die Inanspruchnahme ist, dass ein Energiemanagementsystem, ein Umweltmanagementsystem oder -
                            bei kleinen und mittleren Unternehmen sog. KMU - ein alternatives System zur Verbesserung der Energieeffizienz
                            genutzt wird. Weitere Informationen erhalten Sie auf dieser {createLink(isPdf, 'Zoll-Webseite', url_zoll)}.
                            Der ZDH hat für Handwerksbetriebe des produzierenden Gewerbes eine
                            {createLink(isPdf, 'Informationsschrift über die Regelungen zum Spitzenausgleich', url_direktlink)} sowie eine
                            eigene {createLink(isPdf, 'Webseite', url_spitzenausgleich)} bereitgestellt - beides wird regelmäßig
                            aktualisiert.
                            Mit dem Zusatztool "Zertifizierung" bietet unsere Anwendung eine teilautomatisierte Unterstützung beim Erstellen
                            der für das Alternative System benötigten Nachweistabellen.
                        </WpdfText>
                    </WpdfView>
                </WpdfView> */}
            </WpdfView>
        );
    }

    renderFooter(): JSX.Element {
        const styles: any = this.getStyle(true);

        return (
            <View style={styles.footer} fixed>
                <Text>{Moment().format('DD.MM.YYYY')}</Text>
            </View>
        );
    }

    renderHeader(): JSX.Element {
        const header = require('../../img/logo_mittel2.png');
        const styles: any = this.getStyle(true);
        const unternehmen: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).name
            || (this.props.data.RES_MAIN_LOAD_UNTERNEHMEN_SEL || {}).bezeichnung || null;

        return (
            <View style={styles.header} fixed>
                <Text style={styles.headerText}>E-Tool</Text>
                <Text style={styles.headerSubText}>
                    {parsePdfSub2(unternehmen, styles.headerSubText2)}
                </Text>
                <Image src={header} style={styles.headerImage} />
            </View>
        );
    }

    renderJahresauswahl(): JSX.Element {
        return (
            <DatenauswertungJahrauswahlEinzeln
                jahrMin={this.state.jahrMin}
                jahrMax={this.state.jahrMax}
                jahr={this.state.jahr}
                onJahrChange={(jahr: number) => {
                    // console.log('Jahr change_ ', jahr);
                    this.contextService.set('jahr_cockpit', +jahr);
                    this.setState({ jahr: +jahr });
                }}
            />
        );
    }

    renderLinks(mode: string, isPdf?: boolean) {
        const keys: string[] = [];
        const links: JSX.Element[] = [];
        const styles: any = this.getStyle(isPdf);
        const systemparameter: any[] = this.props.data[IDs.ENT_SYSTEMPARAMETER] || [];
        let padding = 35;

        if (mode === 'strom') {
            keys.push('link_steuer_zoll_strom');
            keys.push('link_steuer_formular_1453');
        }

        if (mode === 'energie') {
            keys.push('link_steuer_zoll_energie');
            keys.push('link_steuer_formular_1118');
            padding = 35;
        }

        // keys.push('link_steuer_formular_1402');
        // keys.push('link_steuer_formular_1130');

        keys.forEach((key: string, index: number) => {
            const item = systemparameter.find((sp: any) => sp.parameter === key);

            if (item.parameter && item.parameter.indexOf('link_steuer') === 0) {
                links.push(
                    <WpdfView style={styles.link} pdf={isPdf} key={`link-${index}`}>
                        {isPdf
                            ? <WpdfText pdf={isPdf}>
                                <Link src={item.wert}>{i18n(item.beschreibung, 'sys')}</Link>
                            </WpdfText>
                            : <span>
                                &rarr;&nbsp;
                                <a
                                    target='_blank'
                                    href={item.wert}
                                >
                                    {i18n(item.beschreibung, 'sys')}
                                </a>
                            </span>
                        }
                    </WpdfView>
                );
            }
        });

        return (
            <WpdfView pdf={isPdf} style={{ paddingTop: padding }}>
                <WpdfView pdf={isPdf}>
                    <WpdfText pdf={isPdf} style={{ fontSize: '9pt', margin: '20px 20px 0 0', textDecoration: 'underline' }}>
                        {i18n('Dokumente und Links', 'sys')}
                    </WpdfText>
                </WpdfView>
                {links}
            </WpdfView>
        );
    }

    async renderPdf(): Promise<void> {
        this.processPdf(
            <Document>
                <Page size='A4' orientation='portrait'>
                    {this.renderHeader()}
                    <View
                        style={{ paddingLeft: 20 }}
                    >
                        <ZusatztoolsSteuerStrom
                            data={this.props.data}
                            jahr={this.state.jahr}
                            hauptzollamt={this.state.hauptzollamt}
                            isPdf
                        />
                        <ZusatztoolsSteuerEnergie
                            data={this.props.data}
                            jahr={this.state.jahr}
                            isPdf
                        />
                    </View>
                    <View
                        style={{ paddingLeft: 25 }}
                    >
                        {this.renderHinweise(true)}
                    </View>
                    {this.renderFooter()}
                </Page>
            </Document>
        );
    }

    renderPdfButton(): JSX.Element {
        return (
            <WActionButton
                label={i18n('PDF generieren', 'sys')}
                insideText={i18n('PDF generieren', 'sys')}
                key='pdf'
                action='pdf'
                onAction={() => this.setState({ isLoading: true }, this.renderPdf)}
            />
        );
    }
}
